import { useEffect, useState } from 'react'

import { Group, Tooltip, Text } from '@mantine/core'
import { DateTimePicker } from '@mantine/dates'

import { useMutation } from '@redwoodjs/web'

import Button from 'src/components/Buttons/Button/Button'
import { toast } from 'src/components/Overlays/Toast/Toast'
import { BULK_CALL } from 'src/graphql/activityLogs.graphql'
import IconPlane from 'src/icons/IconPlane'

const BulkCallDrawer = ({
  applicants,
  refetchQueries = [],
  onClose,
  setLoading,
  setResults,
}) => {
  const [activityDate, setActivityDate] = useState(new Date())

  // MUTATIONS:
  const [bulkCall, { loading: bulkCallLoading }] =
    useMutation(BULK_CALL, {
      refetchQueries: refetchQueries,
      onCompleted: (data) => {
        const results = data?.bulkCall?.applicants
        if (setResults) {
          setResults(
            results?.length
              ? results.map((result) => ({
                  applicantId: result.applicantId,
                  success: result.success,
                  errorMsg: result.errorMsg,
                }))
              : applicants.map((a) => ({
                  applicantId: a.applicantId,
                  success: true,
                }))
          )
        }
        toast('Call was registered successfully', 'success')
      },
      onError: () => {
        if (setResults) {
          setResults(
            applicants.map((a) => ({
              applicantId: a.applicantId,
              success: false,
              errorMsg: 'Failed to register call',
            }))
          )
        }
        toast('Unable to register call, please try again.', 'error')
      },
    })

  useEffect(() => {
    if (setLoading) {
      setLoading(bulkCallLoading)
    }
  }, [bulkCallLoading, setLoading])

  const handleSubmit = () => {
    bulkCall({
      variables: {
        applicants: applicants.map((applicant) => applicant.applicantId),
        activityDate: activityDate.toISOString(),
      },
    })
  }

  return (
    <>
      <div className="flex flex-col gap-4">
        <div className="flex flex-row items-center justify-between">
          <Text size="xs">Date and Time</Text>
          <div className="w-[250px]">
            <DateTimePicker
              value={activityDate}
              onChange={setActivityDate}
              maxDate={new Date()}
              valueFormat="MM/DD/YYYY hh:mm A"
              placeholder="Select date and time"
              size="xs"
              classNames={{
                input: 'text-xs text-right',
              }}
            />
          </div>
        </div>
      </div>

      <Group className="mt-auto grid grid-cols-2">
        <Button
          text="Cancel"
          variant="outline"
          onClick={onClose}
          disabled={bulkCallLoading}
        />
        <Tooltip
          disabled={activityDate && applicants.length > 0}
          label="Please select a date and at least one applicant to send the message"
        >
          <Button
            text={'Register'}
            variant="filled"
            lefticon={<IconPlane />}
            disabled={!activityDate || applicants.length === 0}
            loading={bulkCallLoading}
            onClick={() => {
              handleSubmit()
            }}
          />
        </Tooltip>
      </Group>
    </>
  )
}

export default BulkCallDrawer
